const ROOT_URL = "https://vesta-healing.s3.amazonaws.com";

////////////
// NAVBAR //
////////////
export const HAMBURGER = `${ROOT_URL}/navbar/hamburger.webp`;
export const SIMPLE_LOGO = `${ROOT_URL}/navbar/logo-flame.webp`;
export const BLACK_LOGO = `${ROOT_URL}/navbar/logo-full-black.webp`;

////////////
// FOOTER //
////////////
export const WHITE_LOGO = `${ROOT_URL}/footer/logo-full-white.webp`;
export const CHECK = `${ROOT_URL}/footer/check.svg`;
export const SPIRAL = `${ROOT_URL}/footer/spiral.svg`;

//////////////////
// LANDING PAGE //
//////////////////
export const MIRIAM = `${ROOT_URL}/landing-page/miriam.webp`;
export const HAND_HEART = `${ROOT_URL}/landing-page/hand.webp`;
export const PAPER_PLANE = `${ROOT_URL}/landing-page/paper-plane.webp`;

// HERO
export const HERO_VID = `${ROOT_URL}/landing-page/hero/hero-vid.mp4`;
export const HERO_VID_COVER = `${ROOT_URL}/landing-page/hero/video-cover.webp`;

// AFFILIATES
export const ALMA = `${ROOT_URL}/landing-page/affiliate-icons/alma.webp`;
export const EGPS = `${ROOT_URL}/landing-page/affiliate-icons/egps.webp`;
export const INCLUSIVE_THERAPISTS = `${ROOT_URL}/landing-page/affiliate-icons/inclusive-therapists.webp`;
export const MANHATTAN_ALTERNATIVE = `${ROOT_URL}/landing-page/affiliate-icons/manhattan-alternative.webp`;
export const NQTTCN = `${ROOT_URL}/landing-page/affiliate-icons/nqttcn.webp`;
export const THERAPY_FOR_BLACK_GIRLS = `${ROOT_URL}/landing-page/affiliate-icons/therapy-for-black-girls.webp`;

// METHODS
export const COGNITIVE_BEHAVIORAL = `${ROOT_URL}/landing-page/method-icons/cognitive-behavioral.webp`;
export const DREAMWORK = `${ROOT_URL}/landing-page/method-icons/dreamwork.webp`;
export const EMOTIONAL_PROCESSING = `${ROOT_URL}/landing-page/method-icons/emotional-processing.webp`;
export const MOTIVATIONAL_INTERVIEWING = `${ROOT_URL}/landing-page/method-icons/motivational-interviewing.webp`;
export const PERSON_CENTERED = `${ROOT_URL}/landing-page/method-icons/person-centered.webp`;
export const SHADOW_WORK = `${ROOT_URL}/landing-page/method-icons/shadow-work.webp`;

//////////////
// ABOUT ME //
//////////////
export const HAND_PUZZLE_1 = `${ROOT_URL}/about-me/hand-puzzle1.webp`;
export const HAND_PUZZLE_2 = `${ROOT_URL}/about-me/hand-puzzle2.webp`;
export const SPACE = `${ROOT_URL}/about-me/space.webp`;
export const SPACE_MOBILE = `${ROOT_URL}/about-me/space-mobile.webp`;

//////////////
// SERVICES //
//////////////
export const ASTRONAUT_SINGLE = `${ROOT_URL}/services/astronaut-single.webp`;
export const ASTRONAUT_GROUP = `${ROOT_URL}/services/astronaut-group.webp`;

/////////
// FAQ //
/////////
export const COLLAPSE = `${ROOT_URL}/faq/collapse.svg`;
export const EXPAND = `${ROOT_URL}/faq/expand.svg`;

/////////////////
// BACKGROUNDS //
/////////////////
export const BLACK_LINES = `${ROOT_URL}/backgrounds/black-lines.webp`;
export const ORANGE = `${ROOT_URL}/backgrounds/orange.webp`;
export const ORANGE_MOBILE = `${ROOT_URL}/backgrounds/orange-mobile.webp`;